import { Component, Input, OnDestroy } from '@angular/core';
import { UserService } from '../../services/user.service';
import { LinkService } from '../../services/link.service';
import * as _ from 'lodash';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  user;
  profile;
  linkService;
  userService;
  displayLinks = [];
  displayLinksSub: any;
  settings: any;
  saved = '';

  constructor() {
    this.userService = new UserService();
    this.linkService = new LinkService();
  }

  async userLoaded(user) {
    if (!user || !user.uid) window.location.href = "/login";
    this.user = user;
    this.settings = await this.userService.getUserSettings(user.uid);
    if (!this.settings) {
      this.settings = {
        plan: 'free',
      }
      this.userService.saveUserSettings(true, this.settings, user.uid);
    }
    if (!this.settings.socialLinks) {
      this.settings.socialLinks = {
        facebook: '',
        twitter: '',
        instagram: '',
        youtube: '',
        email: '',
      }
    }
    if (!this.settings.utmParams) {
      this.settings.utmParams = {
        source: '',
        medium: '',
        active: true,
      }
    }
    if (!this.settings.customTheme) {
      this.settings.customTheme = {
        buttonColor: '',
        buttonStyle: '',
        backgroundColor: '',
        backgroundStyle: '',
      }
    }
    this.profile = await this.userService.getProfile(user.uid);
    this.displayLinksSub = this.linkService.getUserLinksSub(user.uid).onSnapshot((data) => {
      this.displayLinks = [];
      data.forEach((doc) => {
        this.displayLinks.push(doc.data());
      });
      this.displayLinks = _.sortBy(this.displayLinks, 'displayOrder');
    });
  }

  updateGradient(grad) {
    console.log(this.settings.customTheme.backgroundColor)
    if (grad === 'up') {
      this.settings.customTheme.backgroundGradient = `linear-gradient(${this.settings.customTheme.backgroundColor || '#ffffff'}, ${this.shadeColor(this.settings.customTheme.backgroundColor || '#ffffff', 0.8)})`;
    } else if (grad === 'down') {
      this.settings.customTheme.backgroundGradient = `linear-gradient(${this.shadeColor(this.settings.customTheme.backgroundColor || '#ffffff', 0.8)}, ${this.settings.customTheme.backgroundColor || '#ffffff'})`;
    } else {
      this.settings.customTheme.backgroundGradient = this.settings.customTheme.backgroundColor || '#ffffff';
    }
    this.updateSocialLinks();
  }

  shadeColor(hex, lum) {

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i*2,2), 16);
      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
      rgb += ("00"+c).substr(c.length);
    }

    return rgb;
  }

//   shadeColor(color, percent) {

//     let R = parseInt(color.substring(1,3),16);
//     let G = parseInt(color.substring(3,5),16);
//     let B = parseInt(color.substring(5,7),16);

//     R = (R * (100 + percent) / 100);
//     G = (G * (100 + percent) / 100);
//     B = (B * (100 + percent) / 100);

//     R = (R<255)?R:255;
//     G = (G<255)?G:255;
//     B = (B<255)?B:255;

//     let RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
//     let GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
//     let BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

//     return "#"+RR+GG+BB;
// }

  updateTheme(theme) {
    this.settings.theme = theme;
    this.userService.saveUserSettings(false, this.settings, this.profile.$id);
  }

  updateSocialLinks() {
    this.userService.saveUserSettings(false, this.settings, this.profile.$id);
  }

  updateIntegrations() {
    this.saved = 'integrations';
    this.userService.saveUserSettings(false, this.settings, this.profile.$id);
    setTimeout(() => {this.saved = '';}, 2000);
  }

  ngOnDestroy() {
    if (this.displayLinksSub) this.displayLinksSub();
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts